import React, { Component } from "react";
import { connect } from "react-redux";
import { hashHistory, withRouter } from "react-router";
import Util from "../util.js";
import NavigatorMain from "./NavigatorMain";
import "./detailInformation.css";
import InfoTable from "./InfoTable.js";
import { getInvestNot, getIncomeDetail, getAllDetail, getStopProfitDetail } from "../action/portfolioAction";
//import H5Page from './product/H5Page.js';
import H5Page from "./product/H5page";
//export const TypeContext = React.createContext({isStop:false});
class BaseInformationStop extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  goVideo = (url) => {
    window.location.href = encodeURI(url/* "https://live.vhall.com/v3/lives/subscribe/981938248" */);
  };

  goBack = () => {
    hashHistory.goBack();
  };

  getInfo = (baseInfo) => {
    // const start = new Date(baseInfo.startDate) != "Invalid Date" ? Util.returnDate(baseInfo.startDate) : "--"; //incomeRateList.startDate
    return [
      [
        [baseInfo && Util.toPercent(baseInfo.profitRate), "止盈目标年化收益率"],
        [baseInfo && baseInfo.runPeriod!=undefined && baseInfo.runPeriod, "运行周期"],
        [baseInfo && baseInfo.investDateStr, "运作起始日期"],
      ],
    ];
  };
  getAll = () => {
    
    hashHistory.push({
      pathname: "/ServiceReport",
      state: { superFundCode: this.props.superFundCode},
      query: { superFundCode: this.props.superFundCode},
    });
  };
  toRecentNewsDetail = (id) => {
    hashHistory.push({
      pathname: "/ServiceReportDetail",
      state: { id },
      query: { id },
    });
  };
  render() {
    const fundName = this.props.superFundName;
    const { strategy, recentNewsList, baseInfo = {}, riskLevelName='--',introVideoUrl } = this.props;

    const infoTable = this.getInfo(baseInfo);

    const recentNewsLists = recentNewsList ? recentNewsList.slice(0, 3) : [];
    const strategyFlag = strategy && strategy.strategy && strategy.strategy.trim();
    const lightPointFlag = strategy && strategy.lightPoint && strategy.lightPoint.trim();
    return (
      <div className="DeInfo_container">
        <div className="DeInfo_strategy_wrap">
          <div className="DeInfo">
            <div className="DeInfo_fundName">
              <div>{fundName}</div>
              {introVideoUrl&&<div onClick={()=>this.goVideo(introVideoUrl)}>视频介绍</div>}
            </div>
            <div className="DeInfo_runtime">
              <span>{riskLevelName}</span>
            </div>
          </div>

          <InfoTable cols={3} dataSouse={infoTable} className="InfoTable" itemClassName="item_table_sec" />

          {(strategyFlag || lightPointFlag) && (
            <div className="strategy">
              {strategyFlag && (
                <div className="strategy_item">
                  <p className="strategy_item_text">
                    <span>投资策略</span> | {strategy.strategy.trim()}
                  </p>
                </div>
              )}
              {lightPointFlag && (
                <div className="strategy_item">
                  <p className="strategy_item_text">
                    <span>策略亮点</span> | {strategy.lightPoint.trim()}
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
        {!!recentNewsLists.length && (
          <div className="DeInfo_dynameic">
            <div className="dynameic" onClick={this.getAll}>
              <img src={require("../img/n_icon_dynameic@2x.png")} />

              <div className="query_more">
                查看全部
                <img src={require("../img/n_icon_right_arrow.png")} />
              </div>
            </div>
            <div className="dynameic_list">
              {recentNewsLists.map((item) => (
                <div key={item.id} className="dynameic_item" onClick={()=>this.toRecentNewsDetail(item.id)} >
                  <div>· {item.title}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { superFund={},strategy, recentNewsList, superFundBasicInfo = {}, stopProfitOperationInfo } = state.strategiesDetails;
  return {
    baseInfo: stopProfitOperationInfo,
    strategy: strategy,
    recentNewsList: recentNewsList,
    riskLevelName: superFundBasicInfo.riskLevelName,
    introVideoUrl:superFund.introVideoUrl
  };
}
export default withRouter(connect(mapStateToProps)(BaseInformationStop));



// WEBPACK FOOTER //
// ./src/components/BaseInformationStop.js